import fire from '../conf/initFirebase';
import moment from "moment";

const newsRef = fire.database().ref('news');
export const NewsActions = Object.freeze({
    FETCH: 'news/FETCH',
    FETCH_SUCCESS: 'news/FETCH_SUCCESS',
    FETCH_FAILURE: 'news/FETCH_FAILURE',
    CREATE: 'news/CREATE',
    CREATE_SUCCESS: 'news/CREATE_SUCCESS',
    CREATE_FAILURE: 'news/CREATE_FAILURE',

    fetch: () => dispatch => {
        dispatch({type: NewsActions.FETCH});
        newsRef.orderByKey().limitToLast(100);
        newsRef.on('value', data => {
            let dataObj = data.val();
            let finalArr = [];
            Object.keys(data.val()).map(o => {
                let object = dataObj[o];
                object['id'] = o;
                finalArr.push(object);
            });
            finalArr.reverse();
            return dispatch({
                type: NewsActions.FETCH_SUCCESS,
                payload: finalArr
            });
        }, err => {
            console.log("error => ", err);
            return dispatch({
                type: NewsActions.FETCH_FAILURE
            })
        })
    },

    add: (values, callback) => dispatch => {
        dispatch({type: NewsActions.CREATE});
        values['created_at'] = moment().format();
        newsRef.push(values);
        if (callback) callback();
        return dispatch({type: NewsActions.CREATE_SUCCESS});
    },

    edit: (values) => {

    }
});


// WEBPACK FOOTER //
// ./src/actions/news.actions.js